export default "__VITE_ASSET__CqE2pbrR__"